module.exports = __webpack_public_path__ + "ded49f35f5e6c803f25bca4cfb1533cd.png";